import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import authApis from '../../../APIs/auth';
import { ReactComponent as CongratulationsSVG } from '../../../assets/congratulations.svg';
import { useRoot } from '../../../context/RootProvider';
import { Button, Typography } from '../../../designComponents';
import { DASHBOARD_ROUTE } from '../../../routes/routePaths';
import { requestAPI } from '../../../utils';
import {
  ActionButtonContainer,
  CongratulationWrapper,
  Container,
} from './onboardingForms.style';

const Congratulations = () => {
  const { updateAuth } = useRoot();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const handleContinue = async () => {
    try {
      setLoading(true);
      const onBoardingData = await requestAPI(
        authApis.onBoarding({
          onboardingStep: 4,
        }),
      );
      setLoading(false);
      updateAuth(onBoardingData.user);
      navigate(DASHBOARD_ROUTE);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  return (
    <Container>
      <Typography variant="title" className="title">
        Congratulations
      </Typography>

      <Typography style={{ marginBottom: '40px' }}>
        Your account has been register successfully. Now you can login to ESCAPE
        PLAN.
      </Typography>
      <CongratulationWrapper>
        <CongratulationsSVG />
      </CongratulationWrapper>
      <ActionButtonContainer>
        <Button
          variant="secondary"
          width="120px"
          onClick={handleContinue}
          isLoading={loading}
        >
          Continue
        </Button>
      </ActionButtonContainer>
    </Container>
  );
};

export default Congratulations;
